
import { GetterTree } from 'vuex';
import { RootState } from '@/store';

import { State } from './state';

export type Getters = {
  getCodigoContrato(state: State, rootState: RootState): any | null;
  getCodigoEscola(state: State, rootState: RootState): any | null;
  getCodigoGrupoUsuario(state: State, rootState: RootState): any | null;
  getCodigoProfessor(state: State, rootState: RootState): any | null;
  getCodigoResponsavel(state: State, rootState: RootState): any | null;
  getCodigoAluno(state: State, rootState: RootState): any | null;
  getCodigoUsuario(state: State, rootState: RootState): any | null;
  getAno(state: State, rootState: RootState): any | null;
  getSemestre(state: State, rootState: RootState): any | null;
  getReadOnly(state: State, rootState: RootState): any | null;
  getChamadaViaProxy(state: State, rootState: RootState): any | null;
  getCodigoEnsino(state: State, rootState: RootState): any | null;
}

export const getters: GetterTree<State, RootState> & Getters = {
  getCodigoContrato: (state, rootState) => state.codigoContrato,
  getCodigoEscola: (state, rootState) => state.codigoEscola,
  getCodigoGrupoUsuario: (state, rootState) => state.codigoGrupo,
  getCodigoProfessor: (state, rootState) => state.codigoProfessor,
  getCodigoResponsavel: (state, rootState) => state.codigoResponsavel,
  getCodigoAluno: (state, rootState) => state.codigoAluno,
  getCodigoUsuario: (state, rootState) => state.codigoUsuario,
  getAno: (state, rootState) => state.ano,
  getSemestre: (state, rootState) => state.semestre,
  getReadOnly: (state, rootState) => state.readOnly,
  getChamadaViaProxy: (state, rootState) => state.chamadaViaProxy,
  getCodigoEnsino: (state, rootState) => state.codigoEnsino,
};
